import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import '.a{display:grid;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.eo{gap:0.75rem;}.ssr-plugin'
import '.as{padding:1rem;}.ssr-plugin'
import '.ep{background-color:var(--palette-blue-50);}.ssr-plugin'
import '.c0{border:none;}.ssr-plugin'
import '.eq{border-radius:1rem;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.er{transition:background-color 0.2s ease;}.ssr-plugin'
import '.el{width:1rem;}.ssr-plugin'
import '.em{height:1rem;}.ssr-plugin'
import '.a5{color:var(--brand-secondary);}.ssr-plugin'
import '.es{font-size:1.15rem;}.ssr-plugin'
import '.a7{font-weight:400;}.ssr-plugin'
import { styled } from 'inlines'
import { useState } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import { Modal } from './Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLink } from '@fortawesome/pro-regular-svg-icons'
import {
  faXTwitter,
  faFacebook,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons'
import { SocialMediaButton } from './SocialMediaButton'

export type SocialShareModalProps = {
  isOpen: boolean
  onClose: () => void
  url?: string
  title?: string
  renderContainer?: HTMLElement
}

export const SocialShareModal = ({
  isOpen,
  onClose,
  url: urlProp,
  title: titleProp,
  renderContainer,
}: SocialShareModalProps) => {
  const translations = useTranslations().app
  const isMobile = useMediaQuery()
  const [copySuccess, setCopySuccess] = useState(false)

  const url =
    urlProp ?? (typeof window !== 'undefined' ? window.location.href : '')
  const title =
    titleProp ?? (typeof document !== 'undefined' ? document.title : '')

  const handleClose = () => {
    setCopySuccess(false)
    onClose()
  }

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setCopySuccess(true)
        setTimeout(() => setCopySuccess(false), 2000)
      })
      .catch((err) => {
        console.error('Failed to copy link:', err)
      })
  }

  const handleEmailShare = () => {
    const subject = encodeURIComponent(`Check out: ${title}`)
    const body = encodeURIComponent(
      `I thought you might be interested in this: ${url}`,
    )
    window.open(`mailto:?subject=${subject}&body=${body}`)
  }

  const handleXShare = () => {
    const text = encodeURIComponent(`Check out: ${title}`)
    window.open(
      `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(url)}`,
    )
  }

  const handleFacebookShare = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    )
  }

  const handleWhatsAppShare = () => {
    const text = encodeURIComponent(`Check out: ${title} - ${url}`)
    window.open(`https://wa.me/?text=${text}`)
  }

  return (
    <Modal
      isOpen={isOpen}
      title={translations.socialShareModal.title}
      onClose={handleClose}
      backLabel={translations.socialShareModal.close}
      renderContainer={renderContainer}
    >
      <div className="d e c"
        data-testid="social-share-modal"
      >
        <div className="a c"
          style={{
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',}}
        >
          <SocialMediaButton
            icon={faEnvelope}
            label={translations.share.email}
            onClick={handleEmailShare}
            isMobile={isMobile}
          />
          <SocialMediaButton
            icon={faXTwitter}
            label={translations.share.x}
            onClick={handleXShare}
            isMobile={isMobile}
          />
          <SocialMediaButton
            icon={faFacebook}
            label={translations.share.facebook}
            onClick={handleFacebookShare}
            isMobile={isMobile}
          />
          <SocialMediaButton
            icon={faWhatsapp}
            label={translations.share.whatsapp}
            onClick={handleWhatsAppShare}
            isMobile={isMobile}
          />
        </div>

        <styled.button className="d t ax n eo as ep c0 eq a1 er"
          onClick={handleCopyLink}
          style={{
            '&:hover': {
              backgroundColor: 'var(--palette-blue-100)',
            },
          }}
        >
          <div className="el em d t ax a5"
          >
            <FontAwesomeIcon icon={faLink} />
          </div>
          <span className="es a5 a7"
          >
            {copySuccess
              ? translations.share.copiedLink
              : translations.share.copyLink}
          </span>
        </styled.button>
      </div>
    </Modal>
  )
}
